"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TagProps", {
  enumerable: true,
  get: function get() {
    return _types.TagProps;
  }
});
Object.defineProperty(exports, "TagRef", {
  enumerable: true,
  get: function get() {
    return _types.TagRef;
  }
});
Object.defineProperty(exports, "TagActionButtonRef", {
  enumerable: true,
  get: function get() {
    return _types.TagActionRef;
  }
});
Object.defineProperty(exports, "IconComponent", {
  enumerable: true,
  get: function get() {
    return _types.IconComponent;
  }
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Typography = require("../Typography");

var _Action = _interopRequireWildcard(require("./Action"));

var _propTypes = require("./propTypes");

var _styles = require("./styles");

var _types = require("./types");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Tag(props, containerRef) {
  var action = props.action,
      actionAttributes = props.actionAttributes,
      actionIcon = props.actionIcon,
      actionIntent = props.actionIntent,
      actionRef = props.actionRef,
      Icon = props.icon,
      text = props.text,
      palette = props.palette,
      _props$size = props.size,
      size = _props$size === void 0 ? 'small' : _props$size,
      rest = _objectWithoutProperties(props, ["action", "actionAttributes", "actionIcon", "actionIntent", "actionRef", "icon", "text", "palette", "size"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var onTagFocus = (0, _react.useCallback)(function (e) {
    var _ref = actionAttributes || {
      onFocus: undefined
    },
        onFocus = _ref.onFocus;

    setIsFocused(true);
    onFocus && onFocus(e);
  }, [actionAttributes]);
  var onTagBlur = (0, _react.useCallback)(function (e) {
    var _ref2 = actionAttributes || {
      onBlur: undefined
    },
        onBlur = _ref2.onBlur;

    setIsFocused(false);
    onBlur && onBlur(e);
  }, [actionAttributes]);
  var ActionElement = (0, _react.useMemo)(function () {
    if (!text || !action || !actionIcon) {
      return null;
    }

    var ActionIcon = actionIcon;
    return _react.default.createElement(_Action.ActionContainer, null, _react.default.createElement(_Action.default, {
      ref: actionRef
    }, _react.default.createElement(ActionIcon, {
      size: "small"
    })));
  }, [text, action, actionRef, actionIcon]);
  var contentIsSingleChild = !action || !!action && !text;
  /**
   * We render the "content" twice below. The first one is visible to the user
   * with and ellipsis, if required, and takes the whole space reserved to the
   * content text. The second component will span the full size it needs for the
   * text to not wrap or display an ellipsis. This makes the container grow as
   * much as it can (up until 300px). We then measure both the container and the
   * seconds content component, and calculate the max width of the container.
   */

  return _react.default.createElement(_styles.Container, _extends({}, rest, actionAttributes, {
    tabIndex: 0,
    size: size,
    isSingleChild: contentIsSingleChild,
    palette: palette,
    ref: containerRef,
    onBlur: onTagBlur,
    onClick: action,
    onFocus: onTagFocus,
    isFocused: isFocused,
    actionIntent: actionIntent
  }), _react.default.createElement(_styles.Content, {
    palette: palette,
    hasIcon: !!Icon,
    isSingleChild: contentIsSingleChild
  }, Icon && _react.default.createElement(Icon, {
    size: "small"
  }), text && _react.default.createElement(_Typography.P, {
    as: "span",
    color: "inherit",
    size: size === 'small' ? 'small' : undefined,
    truncate: true
  }, text)), ActionElement);
}

var TagWithRef = (0, _react.forwardRef)(Tag); // @ts-ignore

TagWithRef.propTypes = _propTypes.propTypes; // @ts-ignore

TagWithRef.defaultProps = _propTypes.defaultProps;
TagWithRef.displayName = 'Tag';
var _default = TagWithRef;
exports.default = _default;